module.exports = __webpack_public_path__ + "img/trip_10.b7ba537f.jpg";